import { render, staticRenderFns } from "./nxAddressReSubmit.vue?vue&type=template&id=007d4e36&scoped=true"
import script from "./nxAddressReSubmit.vue?vue&type=script&lang=js"
export * from "./nxAddressReSubmit.vue?vue&type=script&lang=js"
import style0 from "./nxAddressReSubmit.vue?vue&type=style&index=0&id=007d4e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d4e36",
  null
  
)

export default component.exports